// extracted by mini-css-extract-plugin
export var brand = "_w-9";
export var button = "_w-0";
export var chevron = "_w-v";
export var chevronButton = "_w-w";
export var content = "_w-n";
export var danger = "_w-g";
export var dangerOutlined = "_w-h";
export var dark = "_w-l";
export var darkTheme = "_w-c";
export var extraSmall = "_w-4";
export var fullWidth = "_w-8";
export var ghost = "_w-d";
export var gray = "_w-t";
export var icon = "_w-p";
export var iconButton = "_w-s";
export var iconButtonBorder = "_w-x";
export var iconButtonBorderDark = "_w-y";
export var iconButtonBorderLight = "_w-z";
export var iconLeft = "_w-q";
export var iconRight = "_w-r";
export var large = "_w-1";
export var light = "_w-m";
export var medium = "_w-2";
export var micro = "_w-5";
export var nano = "_w-7";
export var outlined = "_w-k";
export var pending = "_w-a";
export var primary = "_w-i";
export var shadow = "_w-o";
export var small = "_w-3";
export var solidLight = "_w-e";
export var solidLightBrand = "_w-f";
export var spinner = "_w-u";
export var transparent = "_w-j";
export var warning = "_w-b";
export var wideNano = "_w-6";